import { RequestService } from "../../../../common/services/RequestService";
import { ADD_NIGHT_PLACEMENT_TO_LIST } from "./constants";

export const addPlacementToListRequest = async (orderId, payload) => {
  const response = await RequestService.post(
    ADD_NIGHT_PLACEMENT_TO_LIST.replace("{order_id}", orderId),
    payload
  );

  return response;
};
